import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/shared/services/auth.service";
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DBButtonModule, DBIconModule } from '@db/db-core';

@Component({
    selector: 'app-login-forgerock',
    templateUrl: './login-forgerock.component.html',
    styleUrls: ['./login-forgerock.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        DBButtonModule,
        DBIconModule
    ]
})
export class LoginForgerockComponent implements OnInit {
    public loginStarted = false;

    constructor(private auth: AuthService) {}

    ngOnInit() {
        //
    }

    onLogin(): void {
        this.loginStarted = true;
        this.auth.login$().subscribe({
            error: (err: any) => {
                console.error('Login redirect failed', err);
                this.loginStarted = false;
            }
        });
    }
}
